var map = {
	"./custom.png": "2ee8",
	"./generic.png": "e2ae",
	"./redwulf-100A.png": "110e",
	"./redwulf-200A.png": "b8a3",
	"./redwulf-40A.png": "a4e7c",
	"./redwulf-50A.png": "8851",
	"./redwulf-70A.png": "6db3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dad7";